import { CommonDT, DateFilter, PageParams, ResultType, Sorter } from '../../CommonDT';
import { _delete, _get, _post, _put, _req } from '../../request';
import { UserDataType } from '../sys/user-api';
import { UserGroupDataType } from './user-group-api';
import { VideoListDataType } from './video-list-api';

export type UserDetailDataType = CommonDT & {
  nickname: string;
  realname: string;
  userEmail: string;
  userPhone: string;
  userPoints: number;
  userBalance: number;
  frozenPoints: number;
  frozenBalance: number;
  totalConsume: number;
  clockDays: number;
  banDays: number;
  dayHelpRenewDate: Date;
  lastGiftDate: Date;
  unlockContentTime: Date;
  unlockVpayOuttradeNo: string;
  isUnlockContent: number;
  avatarUrl: string;
  fkAvatarMediaUuid: string;
  // fkUserGroupUuid: string;
  fkUpperUserUuid: string;
};

export type UserDetailBatchDataType = {
  userDetails: UserDetailDataType[];
};

export type UserDetailPageDataType = {
  pageParams: PageParams;
  filter?: UserDetailDataType;
  dateFilter?: DateFilter;
  sorter?: Sorter;
};

export type SaveGiftVO = {
  userId: string;
  listId: string;
  postIdList: string[];
};

const get = async (id: string): Promise<ResultType> => {
  return await _get('/usr/userDetail/', id);
};

const getByUserId = async (userId: string): Promise<ResultType> => {
  return await _get('/usr/userDetail/getByUserId/', userId);
};

const getDetail = async (userId: string): Promise<ResultType> => {
  return await _get('/usr/userDetail/getDetail/', userId);
};

const list = async (data?: UserDetailDataType): Promise<ResultType> => {
  return await _post('/usr/userDetail/list', data);
};

const page = async (data?: UserDetailPageDataType): Promise<ResultType> => {
  return await _post('/usr/userDetail/page', data);
};

const batchSave = async (data: UserDetailBatchDataType): Promise<ResultType> => {
  return await _post('/usr/userDetail/batchSave', data);
};

const batchUpdate = async (data: UserDetailBatchDataType): Promise<ResultType> => {
  return await _put('/usr/userDetail/batchUpdate', data);
};

const alterStatus = async (userDetailId: string, status: number): Promise<ResultType> => {
  return await _req('/usr/userDetail/alterStatus', 'PUT', {
    userDetailId,
    status,
  });
};

const batchRemove = async (ids: string[]): Promise<ResultType> => {
  return await _delete('/usr/userDetail/batchRemove', ids);
};

const todayOverGift = async (userId: string): Promise<ResultType> => {
  return await _req('/usr/userDetail/todayOverGift', 'GET', {
    userId,
  });
};

const saveGift = async (saveGift: SaveGiftVO): Promise<ResultType> => {
  return await _req('/usr/userDetail/saveGift', 'POST', {}, saveGift);
};

const UserDetailApi = {
  get,
  getByUserId,
  getDetail,
  list,
  page,
  batchSave,
  batchUpdate,
  alterStatus,
  batchRemove,
  todayOverGift,
  saveGift,
};

export default UserDetailApi;
